import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {request} from 'utils/request-axios';

export type TeamEditGroupOrRoleErrorResponse = Api.Response.Failure<
    keyof TeamEditGroupOrRoleFormFields
>;

export type TeamEditGroupOrRoleFormFields = {
    members: string[];
    name: string;
};

export const usePostTeamEditGroupOrRole = (
    mid: string,
    kind: 'group' | 'role',
): UseMutationResult<
    Api.Response.Success<unknown>,
    TeamEditGroupOrRoleErrorResponse,
    TeamEditGroupOrRoleFormFields
> => {
    const locale = useLocale();

    return useMutation((formData) =>
        request({
            formData,
            locale,
            method: 'POST',
            url: `/ui/team/${kind}/${mid}/edit/`,
        }),
    );
};
